import { createRouter, createWebHistory } from 'vue-router';

import AskedContact from './pages/AskedContact.vue';
import InterestedLanguages from './pages/InterestedLanguages.vue';
import EmailRegisteration from './pages/EmailRegisteration.vue';
import SelectLanguages from './pages/SelectLanguages.vue';
import PersonalDescriptions from './pages/PersonalDescriptions.vue';
import PhoneNumberRegisteration from './pages/PhoneNumberRegisteration.vue';
import SendInformation from './pages/SendInformation.vue';
import ValidateRecaptcha from './pages/ValidateRecaptcha.vue';
import ThankYou from './pages/ThankYou.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/emailregisteration' },
    { path: '/emailregisteration', component: EmailRegisteration },
    { path: '/interestedlanguages', component: InterestedLanguages },
    { path: '/selectlanguages', component: SelectLanguages },
    { path: '/personaldescriptions', component: PersonalDescriptions },
    { path: '/sendinformation', component: SendInformation },
    { path: '/askedcontact', component: AskedContact },
    { path: '/phonenumberregisteration', component: PhoneNumberRegisteration },
    { path: '/validaterecaptcha', component: ValidateRecaptcha },
    { path: '/thankyou', component: ThankYou },
  ],
  linkActiveClass: 'active',
});

export default router;
